import * as actionType from '../../action/language/actionType'



const initialState = {
    lang:'ar',
    dir:'rtl'
}



const languageReducer = (state=initialState, action)=> {
    switch(action.type) {
        case actionType.SET_LANGUAGE: 
            // Ensure Arabic and Urdu always have RTL direction
            const dir = (action.payload.lang === 'ar' || action.payload.lang === 'ur') ? 'rtl' : action.payload.dir;
            return {...state, lang:action.payload.lang, dir: dir}
        default:
            // Ensure Arabic and Urdu always have RTL direction even in default state
            if ((state.lang === 'ar' || state.lang === 'ur') && state.dir !== 'rtl') {
                return {...state, dir: 'rtl'};
            }
            return state;

    }
}


export default languageReducer